export default __webpack_public_path__ + "static/media/collection-banner-carousel--collection-cover-art.31b76749.png";